import React from 'react'

import {  GoogleOAuthProvider} from '@react-oauth/google';

const GoogleProvider = (props) => {
    return (
      <GoogleOAuthProvider clientId='706598596472-vphoe5n73boeeugr88l383hpf1k4srro.apps.googleusercontent.com'>
        {props.children}
      </GoogleOAuthProvider>
    );
  };

export default GoogleProvider;